import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'ClientProfileMfa';
const ENDPOINT = `/client-profile-mfa/`;

@Injectable({
    providedIn: 'root'
})
export class ClientProfileMfaService extends ServiceBase {

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
